import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { FormGroup, FormBuilder } from '@angular/forms';
declare var $: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'form-preview',
    templateUrl: './form-preview.component.html',
    styleUrls: ['./form-preview.component.css']
})
export class FormPreviewComponent implements OnChanges {
    @Input()
    config: any[] = [];

    @Output()
    submitted: EventEmitter<any> = new EventEmitter<any>();

    fieldConfig: any = {};
    form: FormGroup;
    errorMessage = 'Please provide a value!';
    submitButtonClicked = false;
    loading = false;

    constructor(private fb: FormBuilder, private configService: ConfigService) { }

    // every time the form fields are modified, the form group is recreated.
    ngOnChanges() {
        this.form = this.createGroup();
    }

    // function to build the instance of the form (Reactive forms), in simple words, it is
    // much like the syntax of the form and is called every time the form fields are modified.
    createGroup() {
        const group = this.fb.group({});
        this.config.filter(this.notCheckBox).forEach(control => group.addControl(control.name, this.fb.control('', control.validators)));
        this.config.filter(this.isCheckBox).forEach(control => group.addControl(control.name, this.buildCheckBoxOptions(control)));
        return group;
    }

    notCheckBox(field) {
        return field.type !== 'checkbox';
    }

    isCheckBox(field) {
        return field.type === 'checkbox';
    }

    isTermsCheckbox(field) {
        return field.type === 'terms';
    }

    // Function to build a formarray for building a multi option checkbox
    buildCheckBoxOptions(fieldControl) {
        const arr = fieldControl.choices.map(choice => {
            return this.fb.control(choice.checked);
        });
        return this.fb.array(arr, fieldControl.validators);
    }

    // Function to call the function to mark field as required (prepend '*')
    // and then validate field.
    // Example: If a value is not provided for a required field, it displays
    //          a message like "Value is required" right below the field.
    validateField(fieldConfig) {
        if (fieldConfig.validatorInfo.required) {
            this.markRequiredField(fieldConfig.name);
        }
        this.errorMessage = this.configService.getErrorMessage(this.form, fieldConfig);
        return this.configService.validateField(fieldConfig, this.form, this.submitButtonClicked);
    }

    // adds a class "required" to mark a field as required by adding CSS
    // to include a '*' before the label of the respective field.
    markRequiredField(fieldID) {
        $("#" + fieldID).parent('.dynamic-field').addClass('required');
        $("#" + fieldID).attr('aria-invalid', "true");
        $("#" + fieldID).attr('aria-required', "true");
    }

    // To check if form is valid. This generally works with a single check
    // on "form.valid" property, but since we have checkboxes, it would
    // work differently with checkboxes. Hence we would have to perform
    // a different check for multiple checkbox fields and this function
    // serves this purpose.
    isFormValid(form) {
        const formFieldValues = form.value;
        let checkboxValid = true;
        let termsCheckboxValid = true;

        // Checking if all checkbox fields are valid if they are required fields
        this.config.filter(this.isCheckBox).forEach(checkboxField => {
            if (checkboxField.validatorInfo.required) {
                if (!this.configService.isCheckBoxValid(formFieldValues[checkboxField.name])) {
                    checkboxValid = false;
                }
            }
        });

        // Checking if all terms fields are valid if they are required fields
        this.config.filter(this.isTermsCheckbox).forEach(termsCheckboxField => {
            if (termsCheckboxField.validatorInfo.required) {
                if (!formFieldValues[termsCheckboxField.name]) {
                    termsCheckboxValid = false;
                }
            }
        });

        // Checking if all other fields are valid if they are required fields
        if (form.valid) {
            return true && checkboxValid && termsCheckboxValid;
        } else {
            return false;
        }
    }

}
